const fadeIn = (el, timeout, opacity, visibility, display) => {
	el.style.opacity = opacity || 1;
	el.style.display = display || "block";
	el.style.visibility = visibility || "visible";
	el.style.transition = `all ${timeout}ms`;
};

const fadeOut = (el, timeout, opacity, visibility) => {
	el.style.opacity = opacity || 0;
	el.style.visibility = visibility || "hidden";
	el.style.transition = `all ${timeout}ms`;
};

export { fadeIn, fadeOut };
